var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 2 384"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#line_inline_svg__a)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.5,
  d: "M1 1L1.00002 383"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "line_inline_svg__a",
  x1: 0.5,
  x2: 0.5,
  y1: 1,
  y2: 383,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0D4D39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.298,
  stopColor: "#00DD8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.649,
  stopColor: "#00DD8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0D4D39"
})))));
export default SvgLineinline;